const roundNumberToSecondDecimal = (value: number): number => {
  return Math.round(value * 100) / 100;
};

export default roundNumberToSecondDecimal;
